module.exports = __webpack_public_path__ + "static/cross-road-sign-702abb7a856ee2b5c07ab5b5fc53eab5.jpeg";